import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import fetch from 'isomorphic-fetch';
import App from './App';
import Loading from './pages/Loading';
import * as serviceWorker from './serviceWorker';
import filterByAvailableSystems from './lib/filterByAvailableSystems';
import getEnvironment from './lib/environment';
import getSystemsToCheck from './lib/getSystemsToCheck';
import { createBrowserHistory as createHistory } from 'history';
import get from 'lodash/get';

import { isMobile } from '~/genericFunctions';
import { disableMobileXExitPrompt } from '~/lib/mobile-x';
import { Fetch as fetchMaintenanceWindow } from '~/requests/maintenance';
import { retrieveOfferData } from '~/requests/offers';
import stubbedOffersResponse from '~/requests/stubbedOffersResponse';

const environment = getEnvironment();
const history = createHistory();

const initTealium = () => {
  const account = environment.tealium.account;
  const profile = environment.tealium.profile;
  const env = environment.tealium.environment;

  window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
  window.utag_cfg_ovrd.noview = true;

  const script1 = document.createElement('script');
  script1.id = 'utag-sync-script';
  script1.src = `https://tags.tiqcdn.com/utag/${account}/${profile}/${env}/utag.sync.js`;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.id = 'utag-script';
  script2.src = `https://tags.tiqcdn.com/utag/${account}/${profile}/${env}/utag.js`;
  document.head.appendChild(script2);
};

const initialData = async () => {

  let globalData = {
    authToken: global.AUTH_TOKEN,
    authTokenType: global.AUTH_TOKEN_TYPE,
    ismobile: global.IS_MOBILE,
    locale: environment.forceLocale? 'es' : global.LOCALE,
  };

  try {

    if (isMobile(globalData.ismobile)) {
      disableMobileXExitPrompt();
    }

    if (!environment.desktopJourney.isEnabled && !isMobile(globalData.ismobile)) {
      throw new Error('desktop not allowed');
    }

    if (environment.tealium.isEnabled) {
      initTealium();
    }
    ReactDOM.render(
      <Loading show />,
      document.getElementById('root')
    );
    let data, maintenanceWindowResponse;
    if (environment.maintenanceWindow.isEnabled) {
      maintenanceWindowResponse= await fetchMaintenanceWindow(fetch, `${global.window.location.protocol}//${environment.maintenanceWindow.url}`, 'PREAPPROVED');
      if (get(maintenanceWindowResponse, 'underMaintenance')) {
        data = environment.maintenanceWindow.isOfferStubEnabled ? stubbedOffersResponse : undefined;
      } else {
        const retrievedOffers = get(await retrieveOfferData(globalData), 'offers');
        const systemsToCheck = getSystemsToCheck(retrievedOffers);
        let undermaintenanceMap = {};
        await Promise.all(systemsToCheck.map(async (system) => {
          undermaintenanceMap[system] = get(await fetchMaintenanceWindow(fetch, `${global.window.location.protocol}//${environment.maintenanceWindow.url}`, system), 'underMaintenance', false);
        }));
        data = {
          offers: retrievedOffers.filter(filterByAvailableSystems(undermaintenanceMap)),
        };
      }
    } else {
      data = await retrieveOfferData(globalData);
    }
    ReactDOM.render(<App globalData={globalData} history={history} offerData={data} />, document.getElementById('root'));

  } catch (err) {
    if (environment.tealium.isEnabled) {
      initTealium();
    }
    history.push('/error' + history.location.search);
    ReactDOM.render(<App globalData={globalData} history={history} />, document.getElementById('root'));
  }
};
initialData();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
